import _ from 'lodash';
import React from 'react';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import { Keys, locale } from 'src/i18n';
import {
  REVYRE_DETAILS,
  REVYRE_DETAILS_360,
  REVYRE_WORKFLOW_DETAILS,
  REVYRE_WORKFLOW_DETAILS_360,
} from 'src/modules/constants';
import { renderModule } from 'src/workspace/slice';
import { getItemAttributesValues, getModuleNameFromCode } from '../queries';
import styles from './index.module.scss';

export const handleSearchNavigation = (
  item: any,
  type: string,
  dispatch: any,
) => {
  if (type === 'revyre') {
    const workflowType = item?.workflowType;
    const entityId = item?.id;
    const newDetailsPage = getGrowthBookFeatureFlag('enable-details-360');
    if (!['activity', 'approval'].includes(workflowType)) {
      dispatch(
        renderModule({
          id: newDetailsPage
            ? REVYRE_WORKFLOW_DETAILS_360
            : REVYRE_WORKFLOW_DETAILS,
          props: {
            domainType: 'workflow',
            workflowType,
            entityId,
          },
        }),
      );
    } else {
      dispatch(
        renderModule({
          id: newDetailsPage ? REVYRE_DETAILS_360 : REVYRE_DETAILS,
          props: {
            domainType: workflowType,
            entityId,
          },
        }),
      );
    }
    (document.activeElement as HTMLElement)?.blur?.();
  }
};

export const getHighlightValueFromString = (
  highlightValue,
  indexInArray,
  highlightField,
) => {
  if (highlightValue.indexOf('<highlight>') < 0) {
    if (
      highlightValue.length > 20 &&
      indexInArray === 0 &&
      highlightField !== 'name'
    ) {
      return `...${highlightValue.substring(
        highlightValue.length - 20,
        highlightValue.length,
      )}`;
    }

    if (
      highlightValue.length > 20 &&
      indexInArray > 0 &&
      highlightField !== 'name'
    ) {
      return `${highlightValue.substring(0, 20)}...`;
    }

    return highlightValue;
  }

  const actualHighlight = highlightValue.substring(
    highlightValue.lastIndexOf('<highlight>') + 11,
    highlightValue.lastIndexOf('</highlight>'),
  );

  return (
    <span className={styles.navbar__result__item__highlight}>
      {actualHighlight}
    </span>
  );
};

export const getHighlightedDiv = (
  highlightObject,
  isNameFieldCondiv,
  leadName,
) => {
  const allHighlightFields = Object.keys(highlightObject) || [];

  for (let j = 0; j < allHighlightFields.length; j++) {
    const highlightField = allHighlightFields[j];
    if (highlightField) {
      const highlightValuesArray = highlightObject[highlightField] || [];

      for (let i = 0; i < highlightValuesArray.length; i++) {
        const highlightValue = highlightValuesArray[i];
        const allHighlights = highlightValue.split(/(<.*?>.*?<\/.*?>)/g);

        const highlightMarkups = allHighlights.map((eachHighlight, index) =>
          getHighlightValueFromString(eachHighlight, index, highlightField),
        );

        if (highlightField === 'name' && isNameFieldCondiv) {
          return <span>{highlightMarkups}</span>;
        }

        if (
          highlightField !== 'name' &&
          !isNameFieldCondiv &&
          !allHighlightFields.includes('name')
        ) {
          return <span>{highlightMarkups}</span>;
        }
      }
    }
  }

  return leadName;
};

export const getValueFromSnippet = ({ snippet, indices }) => {
  if (!snippet || !indices?.length) return '';

  const { start, end } = indices[0];
  return snippet.slice(start, end);
};

export const renderSearchItemDetails = (item, type) => {
  if (type === 'revyre') {
    const { mutatedEntity } = item || {};

    const renderDescription = (value) =>
      value ? (
        <div className={styles.search__result__item__description}>{value}</div>
      ) : null;

    const renderedFieldsMap = {
      ccase: ['customerName', 'name', 'lan'],
      payment: ['customerName', 'name', 'lan', 'receiptNumber', 'amountPaid'],
      default: ['customerName', 'name'],
    };

    const renderedFields =
      renderedFieldsMap[item?.workflowType] || renderedFieldsMap.default;

    const snippetValue =
      item?.matches
        ?.filter((m) => m?.snippet && !renderedFields.includes(m.field))
        ?.map((m) => m.snippet) || [];

    const fieldMap = {
      ccase: [mutatedEntity?.lan, mutatedEntity?.name, ...snippetValue],
      payment: [
        mutatedEntity?.receiptNumber,
        mutatedEntity?.amountPaid,
        mutatedEntity?.lan,
        mutatedEntity?.name,
        ...snippetValue,
      ],
      default: [mutatedEntity?.name, ...snippetValue],
    };

    const fields = fieldMap[item?.workflowType] || fieldMap.default;

    return (
      <>
        <div className={styles.search__result__item__title}>
          {mutatedEntity?.customerName || mutatedEntity?.name}
        </div>

        {fields.map((value) => (
          <>{renderDescription(value)}</>
        ))}
      </>
    );
  }
  const highlightedDescription = getHighlightedDiv(item.highlight, false, '');

  return (
    <>
      <div>
        <div className={styles.search__result__item__title}>
          {getHighlightedDiv(item.highlight, true, item.name)}
        </div>

        {highlightedDescription && (
          <div className={styles.search__result__item__description}>
            {highlightedDescription}
          </div>
        )}

        {_.map(getItemAttributesValues(item), (v) => (
          <div className={styles.search__result__item__description} key={v}>
            {v}
          </div>
        ))}
      </div>
      <div className={styles.search__result__item__description}>
        {locale(Keys.IN)}
        <span> {getModuleNameFromCode(item.module_code)}</span>
      </div>
    </>
  );
};
